import { getIdentifierName, getTablesConfig, setTablesConfig, updateTableConfig } from "./LocalStorage";
const identifierName = getIdentifierName();

export enum TablesPanel {
  SCHEDULE_INVENTORY = 'scheduleInventory',
  HISTORY_INVENTORY = 'historyInventory',
  SCHEDULE_PLANTING = 'schedulePlanting',
  HISTORY_PLANTING = 'historyPlanting',
  SCHEDULE_APPRAISAL = 'scheduleAppraisal',
  HISTORY_APPRAISAL = 'historyAppraisal',
  SCHEDULE_OPERATION = 'scheduleOperation',
  HISTORY_OPERATION = 'historyOperation'
}

export interface ColumnMapType {
  [columnName: string]: ColumnType;
}

export interface ColumnType {
  label: string;
  visible: boolean;
}

export interface TableConfigurationType {
  [key: string]: {
    columns: ColumnMapType;
  };
}

export let tablesConfiguration: TableConfigurationType = {
  scheduleInventory: {
    columns: {
      identification: { label: identifierName, visible: true },
      treeId: { label: 'Id Árvore', visible: true },
      date: { label: 'Data', visible: true },
      address: { label: 'Endereço', visible: true },
      generalState: { label: 'Estado Geral', visible: true },
      management: { label: 'Manejo', visible: true },
      operation: { label: 'Operação', visible: true },
      osa: { label: 'Osa', visible: true },
      schedule: { label: 'Agendamento', visible: true },
      evaluator: { label: 'Avaliador', visible: true }
    }
  },
  historyInventory: {
    columns: {
      process: { label: 'Processo', visible: true },
      identification: { label: identifierName, visible: true },
      treeId: { label: 'Id Árvore', visible: true },
      date: { label: 'Data', visible: true },
      address: { label: 'Endereço', visible: true },
      generalState: { label: 'Estado Geral', visible: true },
      specie: { label: 'Espécie', visible: true },
      management: { label: 'Manejo', visible: true },
      operation: { label: 'Operação', visible: true },
      osa: { label: 'Osa', visible: true },
      oso: { label: 'Oso', visible: true }
    }
  },
  schedulePlanting: {
    columns: {
      opo: { label: 'Opo', visible: true },
      date: { label: 'Data', visible: true },
      address: { label: 'Endereço', visible: true }
    }
  },
  historyPlanting: {
    columns: {
      opo: { label: 'Opo', visible: true },
      treeId: { label: 'Id Árvore', visible: true },
      date: { label: 'Data', visible: true },
      address: { label: 'Endereço', visible: true },
      specie: { label: 'Espécie', visible: true },
      oso: { label: 'Oso', visible: true },
      operator: { label: 'Operador', visible: true },
      companyProvider: { label: 'Empresa', visible: true }
    }
  },
  scheduleAppraisal: {
    columns: {
      process: { label: 'Processo', visible: true },
      identification: { label: identifierName, visible: true },
      treeId: { label: 'Id Árvore', visible: true },
      protocol: { label: 'Protocolo', visible: true },
      requester: { label: 'Requerente', visible: true },
      serviceType: { label: 'Tipo de serviço', visible: true },
      date: { label: 'Data', visible: true },
      address: { label: 'Endereço', visible: true },
      region: { label: 'Região', visible: true },
      osa: { label: 'Osa', visible: true },
      schedule: { label: 'Agendamento', visible: true },
      evaluator: { label: 'Avaliador', visible: true }
    }
  },
  historyAppraisal: {
    columns: {
      process: { label: 'Processo', visible: true },
      identification: { label: identifierName, visible: true },
      treeId: { label: 'Id Árvore', visible: true },
      osa: { label: 'Osa', visible: true },
      date: { label: 'Data', visible: true },
      requester: { label: 'Requerente', visible: true },
      protocol: { label: 'Protocolo', visible: true },
      evaluator: { label: 'Avaliador', visible: true },
      address: { label: 'Endereço', visible: true },
      region: { label: 'Região', visible: true },
      categoryRisk: { label: 'Categoria de risco', visible: true },
      operation: { label: 'Operação', visible: true },
      comunicationId: { label: 'N° Comunicado', visible: true }
    }
  },
  scheduleOperation: {
    columns: {
      process: { label: 'Processo', visible: true },
      protocol: { label: 'Protocolo', visible: true },
      identification: { label: identifierName, visible: true },
      treeId: { label: 'Id Árvore', visible: true },
      osa: { label: 'Osa', visible: true },
      categoryRisk: { label: 'Categoria de risco', visible: true },
      date: { label: 'Data', visible: true },
      address: { label: 'Endereço', visible: true },
      region: { label: 'Região', visible: true },
      operation: { label: 'Operação', visible: true },
      source: { label: 'Origem', visible: true },
      oso: { label: 'Oso', visible: true },
      schedule: { label: 'Agendamento', visible: true },
      operator: { label: 'Operador', visible: true },
      companyProvider: { label: 'Empresa', visible: true },
      comunicationId: { label: 'N° Comunicado', visible: true }
    }
  },
  historyOperation: {
    columns: {
      process: { label: 'Processo', visible: true },
      identification: { label: identifierName, visible: true },
      treeId: { label: 'Id Árvore', visible: true },
      date: { label: 'Data', visible: true },
      requester: { label: 'Requerente', visible: true },
      oso: { label: 'Oso', visible: true },
      operator: { label: 'Operador', visible: true },
      companyProvider: { label: 'Empresa', visible: true },
      address: { label: 'Endereço', visible: true },
      region: { label: 'Região', visible: true },
      categoryRisk: { label: 'Categoria de risco', visible: true },
      management: { label: 'Manejo', visible: true },
      source: { label: 'Origem', visible: true }
    }
  }
};

export const setTablesConfigurations = () => {
  const configStorage = getTablesConfig();
  if (configStorage) {
    tablesConfiguration = configStorage;
  } else {
    setTablesConfig(tablesConfiguration);
  }
}

export const getTableConfiguration = (tableName: TablesPanel): ColumnMapType  => {
  return tablesConfiguration[tableName].columns;
}

export const setTableConfiguration = (
  tableName: TablesPanel,
  settings: ColumnMapType
) => {
  tablesConfiguration[tableName].columns = settings;

  updateTableConfig(tableName, settings);
}